import { Box, ClickAwayListener } from '@material-ui/core';
import {
  SEmptyState,
  SInfiniteTable,
  SSearchInput
} from '@setvi/shared/components';
import { FC, useRef, useState } from 'react';
import { useAlgoliaProducts } from 'Hooks/useAlgoliaProducts';
import { Product as ProductDTO } from '@setvi/shared/interfaces';
import { TableLoader } from '@setvi/shared/components/s-table/components/table-loader';
import { useStyles } from './style';
import { useSearchColumns } from './use-search-columns';

interface ProductsSearchProps {
  onProductClick: (product: ProductDTO) => void;
  segmentId?: string;
}

export const ProductsSearch: FC<ProductsSearchProps> = ({
  onProductClick,
  segmentId
}) => {
  const classes = useStyles();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const anchorRef = useRef<HTMLDivElement | null>(null);
  const searchInputRef = useRef(null);

  const {
    searchQuery,
    isLoading: isSearchLoading,
    products: algoliaProducts,
    searchProducts,
    refetchProducts,
    fetchMore
  } = useAlgoliaProducts({ segmentId });

  const { columns } = useSearchColumns({ searchQuery });

  const handleClickAway = () => {
    setIsDropdownOpen(false);
    refetchProducts();
  };

  const handleFocus = () => {
    setIsDropdownOpen(true);
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div ref={anchorRef}>
        <SSearchInput
          ref={searchInputRef}
          loading={isSearchLoading}
          defaultValue={searchQuery}
          width={500}
          onChange={searchProducts}
          onFocus={handleFocus}
          placeholder="Enter SKU or Product Name"
        />
        {isDropdownOpen && (
          <Box className={classes.dropdown}>
            {isSearchLoading && <TableLoader rows={5} />}

            {!isSearchLoading && algoliaProducts.length === 0 && (
              <SEmptyState subTitle="No products found" />
            )}

            {!isSearchLoading && algoliaProducts.length > 0 && (
              <SInfiniteTable
                header={{
                  hide: true
                }}
                list={algoliaProducts}
                columns={columns}
                keyGetter={(product: any) => product._id}
                row={{
                  onClick: product => {
                    onProductClick(product);
                    setIsDropdownOpen(false);
                    searchInputRef.current?.setValue('');
                  }
                }}
                infiniteScroll={{
                  fetchMore
                }}
              />
            )}
          </Box>
        )}
      </div>
    </ClickAwayListener>
  );
};
